module.exports = __webpack_public_path__ + "img/already.8f479e59.svg";